import React from "react";
import { cn } from "@/lib/utils";

const SIZE = {
  sm: 12,
  md: 16,
  lg: 24,
};

/**
 * Small violet ring. Under `prefers-reduced-motion: reduce`, renders three
 * static dots instead of a spinning ring — no infinite motion.
 */
export function Spinner({ size = "md", className, "aria-label": ariaLabel = "Loading" }) {
  const px = SIZE[size] ?? SIZE.md;
  return (
    <span
      role="status"
      aria-label={ariaLabel}
      className={cn("inline-flex items-center justify-center", className)}
      data-testid="spinner"
    >
      <svg
        className="frac-spinner"
        width={px}
        height={px}
        viewBox="0 0 24 24"
        fill="none"
        aria-hidden="true"
      >
        <circle
          cx="12"
          cy="12"
          r="9"
          stroke="currentColor"
          strokeOpacity="0.22"
          strokeWidth="3"
        />
        <path
          d="M21 12a9 9 0 0 0-9-9"
          stroke="currentColor"
          strokeWidth="3"
          strokeLinecap="round"
        />
      </svg>
      <span className="frac-spinner-dots" aria-hidden="true">
        <span />
        <span />
        <span />
      </span>
    </span>
  );
}

export default Spinner;
